module.exports = __webpack_public_path__ + "img/tooltip.edb8d604.svg";